/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

import NotFound from 'vcomponents/errors/NotFound.vue';
import ErrorCartExpired from 'vcomponents/pages/errors/ErrorCartExpired.vue';

export default [
    {
        path: '/not-found',
        component: NotFound,
        name: 'error.not.found',
        props: true
    },
    {
        path: '/cart-expired',
        component: ErrorCartExpired,
        name: 'error.cart.expired',
        props: true
    },
];
